import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import { productsAPI } from "../../services/productsService";
import { IBrand } from "../types/brandsTypes";
import { IBrandsState } from "Interfaces/interface.brands";

const brandsAdapter = createEntityAdapter({
  selectId: (brand: IBrand) => brand.id,
});

const initialState = brandsAdapter.getInitialState<IBrandsState>({
  status: "idle",
  error: null,
  isBrandsLoaded: false,
});

export const fetchBrands = createAsyncThunk(
  "brands/fetchBrands",
  async (_, { rejectWithValue }) => {
    try {
      const brands = await productsAPI.fetchBrands();
      return brands.map((brand, index) => ({
        ...brand,
        id: brand.id || index.toString(),
      }));
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const brandsSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrands.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.status = "succeeded";
        brandsAdapter.setAll(state, action.payload);
        state.isBrandsLoaded = true; // Set when fetch succeeds
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const { selectAll: selectAllBrands } = brandsAdapter.getSelectors(
  (state: any) => state.brands
);
export default brandsSlice.reducer;

export const selectBrandsStatus = (state: any) => state.brands.status;
export const selectBrandsError = (state: any) => state.brands.error;
export const selectIsBrandsLoaded = (state: any) => state.brands.isBrandsLoaded;
